/** Assistant « dans la 3D » : relie une question à un point d'intérêt.
 *  - sans endpoint : correspondance par mots-clés (hotspot.keywords + titre + texte)
 *  - avec endpoint : POST { question, product, hotspots } → { answer, hotspot? }  (proxy serveur vers un LLM) */
const norm = s => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

export async function answer(question, product, cfg = {}) {
  const hs = product.hotspots || [];
  if (cfg.endpoint) {
    try {
      const r = await fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question, product: { id: product.id, name: product.name }, hotspots: hs.map(h => ({ id: h.id, title: h.title, text: h.text, keywords: h.keywords })) }) });
      const j = await r.json();
      if (j && j.answer) return { answer: j.answer, hotspot: hs.find(h => h.id === j.hotspot) || null };
    } catch {}
  }
  const q = norm(question).split(/[^a-z0-9]+/).filter(w => w.length > 2);
  let best = null, score = 0;
  for (const h of hs) {
    const bag = norm([...(h.keywords || []), h.title, h.text].join(' '));
    const s = q.reduce((a, w) => a + (bag.includes(w) ? (h.keywords || []).some(k => norm(k).includes(w)) ? 3 : 1 : 0), 0);
    if (s > score) { score = s; best = h; }
  }
  if (best) return { answer: `${best.title} — ${best.text}`, hotspot: best };
  return { answer: cfg.fallback || 'Je peux vous montrer l\'appareil photo, l\'écran, la recharge ou les finitions. Que voulez-vous voir ?', hotspot: null };
}
